import { Grid, Typography } from '@mui/material';
import { titleSX, getGridItemSX } from '@/components/blocks/DpLibrary/DpBFBannerAds/style/main';

export const DpBuenFinBannerAds = ({ image, title }: { image: string; title: string }) => (
	<Grid sx={getGridItemSX(image)}>
		<Typography component="h2" sx={titleSX}>
			{title}
		</Typography>
	</Grid>
);
